$(document).ready(function(e){
  console.log(
  "%cCustom JS is ready",
  "background: linear-gradient(90deg, rgba(2,0,36,1) 0%, rgba(121,9,42,1) 35%, rgba(0,212,255,1) 100%); color: #FFF; font-weight: bold; font-size: 50px;"
);

//top header slider
  
$('.hd-text-slide').slick({
    dots: false,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 4000,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: false
  });

  // Detect scroll event
  $(window).on('scroll', function() {
    // Check if the user has scrolled back to the top
    if ($(window).scrollTop() === 0) {
      // Refresh the slick slider
      $('.hd-text-slide').slick('refresh');
    }
  });



//Index-1 slider
  
 $('.indx1-slide').slick({
   dots: false,
   arrows:true,
   autoplay: true,
   autoplaySpeed: 5000,
   // cssEase: 'linear',
   infinite: true,
   speed: 800,
   slidesToShow: 1,
   slidesToScroll: 1,
   adaptiveHeight: false,
   responsive: [
     {
       breakpoint: 768,
       settings: {
         slidesToShow: 1,
         slidesToScroll: 1,
         dots:true,
         arrows:false
       }
     }
   ]
 });


//Panache Index-1 slider
  
 $('.pIndx1-slide').slick({
   dots: true,
   arrows:false,
   autoplay: true,
   autoplaySpeed: 5000,
   // cssEase: 'linear',
   infinite: true,
   speed: 800,
   slidesToShow: 1,
   slidesToScroll: 1,
   adaptiveHeight: false,
   responsive: [
     {
       breakpoint: 768,
       settings: {
         slidesToShow: 1,
         slidesToScroll: 1,
         dots:true,
         arrows:false
       }
     }
   ]
 });


  

//index collection list slider

 $('.indx-coll-list').slick({
   dots: false,
   arrows:true,
   infinite: false,
   speed: 300,
   slidesToShow: 4,
   slidesToScroll: 1,
   adaptiveHeight: false,
   prevArrow:"<div  class='slick-prev pull-left'><svg width='9' height='16' viewBox='0 0 9 16' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M0.562502 7.99996C0.562413 8.08615 0.579354 8.17151 0.612352 8.25113C0.645349 8.33075 0.693753 8.40307 0.754782 8.46393L7.31728 15.0264C7.57371 15.2829 7.98895 15.2829 8.24522 15.0264C8.50149 14.77 8.50165 14.3548 8.24522 14.0985L2.14669 7.99996L8.24522 1.90143C8.50165 1.645 8.50165 1.22976 8.24522 0.97349C7.98879 0.717224 7.57355 0.71706 7.31728 0.97349L0.754783 7.53599C0.693753 7.59685 0.645349 7.66917 0.612352 7.74879C0.579354 7.82841 0.562413 7.91377 0.562502 7.99996Z' fill='black'/></svg></div>",
   nextArrow:"<div  class='slick-next pull-right'><svg width='9' height='16' viewBox='0 0 9 16' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M8.78276 7.99996C8.78284 8.08615 8.7659 8.17151 8.73291 8.25113C8.69991 8.33075 8.6515 8.40307 8.59047 8.46393L2.02797 15.0264C1.77154 15.2829 1.3563 15.2829 1.10004 15.0264C0.843771 14.77 0.843607 14.3548 1.10004 14.0985L7.19857 7.99996L1.10004 1.90143C0.843607 1.645 0.843607 1.22976 1.10004 0.97349C1.35647 0.717224 1.77171 0.71706 2.02797 0.97349L8.59047 7.53599C8.6515 7.59685 8.69991 7.66917 8.73291 7.74879C8.7659 7.82841 8.78284 7.91377 8.78276 7.99996Z' fill='black'/></svg></div>",
   responsive: [
     {
       breakpoint: 1199,
       settings: {
         slidesToShow: 4,
         slidesToScroll: 1
       }
     },
     {
       breakpoint: 992,
       settings: {
         slidesToShow: 3,
         slidesToScroll: 1
       }
     },
     {
       breakpoint: 768,
       settings: {
         slidesToShow: 2,
         slidesToScroll: 1
       }
     },
     {
       breakpoint: 600,
       settings: {
         slidesToShow: 1,
         slidesToScroll: 1
       }
     }
   ]
 });


//index-6 featured collection slider

 $('.indx6-ftcollslide').slick({
   dots: false,
   arrows:true,
   infinite: false,
   speed: 300,
   slidesToShow: 4,
   slidesToScroll: 1,
   adaptiveHeight: false,
   prevArrow:"<div  class='slick-prev pull-left'><svg width='9' height='16' viewBox='0 0 9 16' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M0.562502 7.99996C0.562413 8.08615 0.579354 8.17151 0.612352 8.25113C0.645349 8.33075 0.693753 8.40307 0.754782 8.46393L7.31728 15.0264C7.57371 15.2829 7.98895 15.2829 8.24522 15.0264C8.50149 14.77 8.50165 14.3548 8.24522 14.0985L2.14669 7.99996L8.24522 1.90143C8.50165 1.645 8.50165 1.22976 8.24522 0.97349C7.98879 0.717224 7.57355 0.71706 7.31728 0.97349L0.754783 7.53599C0.693753 7.59685 0.645349 7.66917 0.612352 7.74879C0.579354 7.82841 0.562413 7.91377 0.562502 7.99996Z' fill='black'/></svg></div>",
   nextArrow:"<div  class='slick-next pull-right'><svg width='9' height='16' viewBox='0 0 9 16' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M8.78276 7.99996C8.78284 8.08615 8.7659 8.17151 8.73291 8.25113C8.69991 8.33075 8.6515 8.40307 8.59047 8.46393L2.02797 15.0264C1.77154 15.2829 1.3563 15.2829 1.10004 15.0264C0.843771 14.77 0.843607 14.3548 1.10004 14.0985L7.19857 7.99996L1.10004 1.90143C0.843607 1.645 0.843607 1.22976 1.10004 0.97349C1.35647 0.717224 1.77171 0.71706 2.02797 0.97349L8.59047 7.53599C8.6515 7.59685 8.69991 7.66917 8.73291 7.74879C8.7659 7.82841 8.78284 7.91377 8.78276 7.99996Z' fill='black'/></svg></div>",
   responsive: [
     {
       breakpoint: 1199,
       settings: {
         slidesToShow: 4,
         slidesToScroll: 1
       }
     },
     {
       breakpoint: 992,
       settings: {
         slidesToShow: 3,
         slidesToScroll: 1
       }
     },
     {
       breakpoint: 768,
       settings: {
         slidesToShow: 2,
         slidesToScroll: 1
       }
     },
     {
       breakpoint: 600,
       settings: {
         slidesToShow: 1,
         slidesToScroll: 1
       }
     }
   ]
 });


//index-10 slider

 $('.indx10-slide').slick({
   dots: false,
   arrows:true,
   infinite: false,
   speed: 300,
   slidesToShow: 4,
   slidesToScroll: 1,
   adaptiveHeight: false,
    prevArrow:$(".slidePrev"),
    nextArrow:$(".slideNext"),
   responsive: [
     {
       breakpoint: 1199,
       settings: {
         slidesToShow: 4,
         slidesToScroll: 1
       }
     },
     {
       breakpoint: 769,
       settings: {
         slidesToShow: 3,
         slidesToScroll: 1
       }
     },
     {
       breakpoint: 641,
       settings: {
         slidesToShow: 2,
         slidesToScroll: 1
       }
     },
     {
       breakpoint: 420,
       settings: {
         slidesToShow: 1,
         slidesToScroll: 1
       }
     }
   ]
 });

// index-3 slider

$('.indx3-slider').slick({
   autoplaySpeed: 1000,
   pauseOnHover: true,
   slidesToShow: 1,
   slidesToScroll: 1, 
   arrows: true,
   dots: false,
   infinite: false,
   fade: true,
   asNavFor: '.slider-nav'
});
$('.slider-nav').slick({
   slidesToShow: 1,
   slidesToScroll: 1,
   arrows: false,
   dots: false,
   infinite: false,
   focusOnSelect: true,
   asNavFor: '.indx3-slider',
   fade: true,
    cssEase: 'ease-in-out',
});



//Panche Index 10 slider

 $('.pindx10-slide').slick({
   dots: false,
   arrows:true,
   infinite: false,
   speed: 300,
   slidesToShow: 3,
   slidesToScroll: 1,
   adaptiveHeight: false,
    // prevArrow:$(".slidePrev"),
    // nextArrow:$(".slideNext"),
   responsive: [
     {
       breakpoint: 1199,
       settings: {
         slidesToShow: 3,
         slidesToScroll: 1
       }
     },
     {
       breakpoint: 769,
       settings: {
         slidesToShow: 2,
         slidesToScroll: 1
       }
     },
     {
       breakpoint: 641,
       settings: {
         slidesToShow: 1,
         slidesToScroll: 1
       }
     }
   ]
 });




  
// for panache index 4 tab


  $('ul.tabs').each(function(){
      var active, content, links = $(this).find('a');
      active = links.first().addClass('active');
      content = $(active.attr('href'));
      links.not(':first').each(function () {
        $($(this).attr('href')).hide();
      });
      $(this).find('a').click(function(e){
        active.removeClass('active');
        content.hide();
        active = $(this);
        content = $($(this).attr('href'));
        active.addClass('active');
        content.show();
        return false;
      });
    });



  
  
//refresh slick on tab click for loading
  
//$('ul.tabs li a').on('click', function () {
  //  $('.indx3-slide').slick('refresh');
 // });
  




//for FAQ

  
$(function() {
$('.accordion .acc-headng-main').click(function(){
$(this).parent().toggleClass(' active ');
$(this).parent().siblings().removeClass('active');

$(this).parent().children(".content-box").toggleClass('open').slideToggle();
$(this).parent().siblings().children(".content-box").removeClass('open').slideUp();
return false;
});
});
 






  


  
  

});